@if (entity?.procallState) {
  <div>
    <div class="fs-6 fw-bold jumbotron mt-2">
      <div class="row d-flex align-items-center">
        <div class="col-md-4">
          @if (!isPlaybackMode()) {
            <span>Current Procall</span>
          }
          @if (isPlaybackMode()) {
            <span>Procall Playback</span>
          }
        </div>
        <div class="col-md-4"></div>
        @if ((isPendingProcall() || isOpenProcall()) && isMonitorMode()) {
          <div class="col-md-4">
            <button type="button" class="btn btn-danger" (click)="goLiveProcall()"><i class="glyphicon glyphicon-globe"></i></button>
          </div>
        }
        @if (isPendingProcall() && isLiveMode()) {
          <div class="col-md-4">
            <button type="button" class="btn btn-primary" style="width:90px;" (click)="openProcall()">Open</button>
          </div>
        }
        @if (isOpenProcall() && isLiveMode()) {
          <div class="col-md-4">
            <button type="button" class="btn btn-primary" style="width:90px;" (click)="resolveProcall()">Resolve
              <i class="fa fa-thumbs-o-up ms-1" aria-hidden="true"></i>
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- Calendar -->
@if (entity?.calendarState) {
  <div>
    <div class="jumbotron min-padding-jumbo">
      <div class="row d-flex align-items-center">
        <div class="col-md-6">
          Current Calendar Event
        </div>
        <div class="col-md-4">
          <button type="button" class="btn btn-info" (click)="getCalendarInfo()">
            <i class="glyphicon glyphicon-info-sign"></i>
          </button>
        </div>
        @if (isMonitorMode()) {
          <div class="col-md-4">
            <button type="button" class="btn btn-danger" (click)="goLiveCalendar()"><i class="glyphicon glyphicon-globe"></i></button>
          </div>
        }
        @if (isLiveMode()) {
          <div class="col-md-4">
            <button type="button" class="btn btn-primary btn-width-80" (click)="resolveCalendar()">Check In</button>
          </div>
        }
      </div>
    </div>
    <br>
    </div>
  }

  <!-- Active Tracking -->
  @if (entity?.activeTrackingState) {
    <div>
      <div class="jumbotron min-padding-jumbo">
        <div class="row d-flex align-items-center">
          <div class="col-md-6">
            @if (!isPlaybackMode()) {
              <span>Current Active Tracking</span>
            }
            @if (isPlaybackMode()) {
              <span>Active Tracking Playback</span>
            }
          </div>
          <div class="col-md-4">
            <button type="button" class="btn btn-info" (click)="getTrackingInfo()">
              <i class="glyphicon glyphicon-info-sign"></i>
            </button>
          </div>
          @if (isMonitorMode()) {
            <div class="col-md-4">
              <button type="button" class="btn btn-danger" (click)="goLiveTracking()"><i class="glyphicon glyphicon-globe"></i></button>
            </div>
          }
          @if (isLiveMode()) {
            <div class="col-md-4">
              <button type="button" class="btn btn-primary btn-width-80" (click)="resolveTracking()">Check In</button>
            </div>
          }
        </div>
      </div>
    </div>
  }

  <!-- Playback Mode Table -->
  @if (isPlaybackMode() && (entity?.activeTrackingState || entity?.procallState)) {
    <div>
      <div class="jumbotron mt-2">
        <div class="row d-flex align-items-center">
          <div class="fs-6 col-md-12">
            <table class="w-100">
              <tr><td class="table-label-width">Start:</td><td> {{getStartTime()}}</td></tr>
              <tr><td>End:</td><td> {{getEndTime()}}</td></tr>
              <tr><td>Total Duration:</td><td> {{getTotalDuration()}}</td></tr>
              <tr><td>Elaped Time:</td><td> {{getElapsedTime()}} @if (isPlaybackMode()) {
              <span> ({{getElapsedTimePct()}}%) </span>
            }  </td></tr>
          </table>
        </div>
      </div>
    </div>
  </div>
}

<!-- Non-Playback Mode Table -->
@if (!isPlaybackMode() && (entity?.activeTrackingState || entity?.procallState)) {
  <div>
    <div class="jumbotron min-padding-jumbo">
      <div class="row d-flex align-items-center">
        <div class="col-md-12">
          <table class="w-100">
            <tr><td class="table-label-width">Start:</td><td> {{getStartTime()}}</td></tr>
            <!-- End/Total Duration not shown for active tracking -->
            <tr><td>Elaped Time:</td><td> {{getElapsedTime()}}</td></tr>
          </table>
        </div>
      </div>
    </div>
    <br>
    </div>
  }

  <!-- Address and Perimeter -->
  <div>
    <div class="jumbotron fs-6 mt-2 fw-bold">
      <div class="row d-flex align-items-center">
        <div class="col-md-12 fs-6 address-width">
          <div class="fw-bold">
            Address for Current Location [<i class="fa fa-refresh cursor-pointer" title="update address" (click)="refreshLocation()"></i>]:<br>
          </div>
          <div class="fw-normal"><i>{{printLocation}}</i></div>
        </div>
      </div>
      @if (isInBuilding) {
        <div class="row d-flex align-items-center">
          <button type="button" class="btn btn-primary col-2 ms-3" (click)="viewPerimeter()">
            <i class="fa fa-building" aria-hidden="true"></i>
          </button>
        </div>
      }
    </div>
    <br>
    </div>

    <!-- Tabs -->
    <ul class="nav nav-tabs gap-2">
      <li [class.active]="show === INFO"><a (click)="setShow(INFO)">Info </a></li>
      <li [class.active]="show === MESSAGES"><a (click)="setShow(MESSAGES)">Messages ({{data.numberTotal}}) </a></li>
      @if (isPlaybackMode() && (isProcallPlayback || isTrackingPlayback)) {
        <li [class.active]="show === VIDEO">
          <a (click)="setShow(VIDEO)">Video ({{data.numberTotalVideo}}) </a>
        </li>
      }
    </ul>

    <div>
      @if (getShow(INFO)) {
        <div class="fs-6 tab-pane in active details-text">
          <div class="row">
            <div class="col-lg-3">
              <h6 class="mt-0">Email</h6>
            </div>
            <div class="col-lg-9">
              <p>: {{entity?.getUserDto()?.getEmail()}}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">
              <h6 class="mt-0">Phone</h6>
            </div>
            <div class="col-lg-9">
              <p>: {{entity?.getUserDto()?.getPhone()}}</p>
            </div>
          </div>
          <!--
          <div class="row">
            <div class="col-lg-3">
              <h6 class="mt-0">Subscription</h6>
            </div>
            <div class="col-lg-9">
              <p>: {{showSubscriptions()}}</p>
            </div>
          </div>
          -->
          <div class="row">
            <div class="col-lg-3">
              <h6 class="mt-0">More information</h6>
            </div>
            <div class="col-lg-9">
              <i class="fa fa-info float-start cursor-pointer" (click)="showUserBaseballcard()"></i>
            </div>
          </div>
        </div>
      }

      @if (getShow(MESSAGES)) {
        <div class="tab-pane in">
          @if (data.messageListFull.length > 0) {
            <div>
              <div class="message-scroll-container">
                Messages During Event:
                @for (item of data.messageListFull; track item) {
                  <table class="table custom-table mb-0">
                    <tbody>
                      <tr><td class="p-0">
                        <table class="table custom-table">
                          <tr>
                            <td>From: {{item.from}}; To: {{item.to}} <span class="float-end">{{item.time}}</span></td>
                          </tr>
                          <tr>
                            <td>Subject: {{item.subjectStr}}</td>
                            <tr>
                              <td class="pt-2">{{item.text}}</td>
                            </tr>
                          </table>
                        </td></tr>
                      </tbody>
                    </table>
                  }
                </div>
              </div>
            }
          </div>
        }

        @if (getShow(VIDEO)) {
          <div class="tab-pane in">
            @if (isPlaybackMode()) {
              <div>
                <div class="video-scroll-container">
                  Recorded Video:
                  <table class="w-100">
                    <tr class="video-table-header"><td>Camera Name</td><td>Session</td><td>Start</td><td>End</td><td>Duration</td></tr>
                    @for (session of playbackCameraSessions; track session) {
                      <tr>
                        <td><i class="fa fa-video-camera cursor-pointer" title="play" (click)="playbackVideo(session)"></i> {{session.camera.label}}</td>
                        <td>{{session.id}}</td>
                        <td>{{session.startTime.slice(11, 19)}}</td>
                        <td>{{session.endTime.slice(11, 19)}}</td>
                        <td>{{session.duration}}</td>
                      </tr>
                    }
                  </table>
                </div>
              </div>
            }
          </div>
        }
      </div>